import type { Action } from 'flow/store/engine/types';
import { ActionType } from 'flow/store/engine/constants';
import { createActionsThunk } from 'flow/store/redux/thunks';
import {
  findNextActionPrecedence,
  PREVIEW_WORKFLOW_ROUTING_ACTION_NAME,
} from 'flow/service/actions';

import type { useAppDispatch } from '~/store/reduxHooks';


export function handleOnAddWorkflowRoutingClick(
  dispatch: ReturnType<typeof useAppDispatch>,
  workflowRoutingActions: Action[],
  publicId?: Action['publicId'],
) {
  const name = PREVIEW_WORKFLOW_ROUTING_ACTION_NAME;
  const precedenceIndex = findNextActionPrecedence(workflowRoutingActions);

  dispatch(createActionsThunk({
    type: ActionType.WORKFLOW,
    args: {
      name,
      precedenceIndex,
      workflowId: null,
      ...(publicId && { publicId }),
    },
  }));
}
